import type { Component } from "svelte";
import { get, writable, type Writable } from "svelte/store";

const target: Writable<HTMLDialogElement> = writable();
const component: Writable<Component | null> = writable();
const props: Writable<any> = writable();

export const useDialog = () => {
	function open(component_: any, props_?: any) {
		props.set(props_);
		component.set(component_);
		get(target).showModal();
	}

	function close() {
		component.set(null);
		get(target).close();
	}

	return {
		component,
		props,
		open,
		close,
		target: target
	};
};
